module.exports = __webpack_public_path__ + "img/start-chat.c712baf.svg";